






























































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import DateUtils from '@/utils/DateUtils';
import { removeTrailingZeros } from '@/utils/moneyFormarter';
import { getNeedsOnboardingCall } from '@/utils/onboardingCall';

@Component({
  components: { Typography }
})
export default class DelayedPlanOverview extends Vue {
  @Prop({ default: {} }) subscription!: any;

  get tPrefix() {
    return 'modals.billing.delayedPlanOverview';
  }

  get locationsAmount() {
    return this.subscription.totalLocations || ' ';
  }

  get needsOnboardingCall() {
    return getNeedsOnboardingCall();
  }

  get coinsAmount() {
    if (!this.subscription.totalFee) return ' ';

    return removeTrailingZeros(this.subscription.totalFee || 0);
  }

  get startMitingDate() {
    return this.getDate(this.subscription.nextPaymentAt);
  }

  getDate(date: string) {
    return DateUtils.formattedDate({
      date
    });
  }
}
